import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./Pages/Home";
import ScrollToTop from "./Components/ScrollToTop";
import BackToTopButton from './Components/BackToTop';
import Footer from "./Components/footer";
import Header from "./Components/Header";
import Contact from "./Pages/Contact";
import Appraisal from "./Pages/Appraisal";
import TermsAndConditions from "./Pages/TermsAndConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Services from "./Pages/Services";
import About from "./Pages/About";
import Team from "./Pages/Team";
import Properties from "./Pages/Properties";
import FAQ from "./Pages/FAQ";
import News from "./Pages/News";
import TeamDetails from "./Pages/TeamDetails";
import PropertyDetails from "./Pages/PropertyDetails";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/appraisal" element={<Appraisal />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team-details/:name" element={<TeamDetails />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property-details/:slug" element={<PropertyDetails />} />
          {/* <Route path="/faq" element={<FAQ />} /> */}
          <Route path="/news" element={<News />} />
        </Routes>
      </div>
      <Footer />
      <BackToTopButton />
    </Router>
  );
}

export default App;